import React, { useRef } from "react";
import clsx from "clsx";

export function OverflowFrame({ children, handleScroll, isMobile }) {
  const scrollRef = useRef(null);

  return (
    <div
      className={clsx(
        "",
        !isMobile &&
          "scrollbar overflow-y-auto max-lg:h-[calc(100vh-12em)] h-[calc(100vh-7em)] mr-[-16px]",
      )}
      ref={scrollRef}
      onScroll={() => handleScroll && handleScroll(scrollRef)}
    >
      <div className="pr-[16px] md:mx-5">{children}</div>
    </div>
  );
}
